// components/StopDetails.jsx
import React, { useState, useEffect } from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
import { fetchDepartures, fetchStops } from '../services/api';
import StopHeader from './StopHeader';
import DeparturesList from './DeparturesList';
import StopTimetable from './StopTimetable';
import useFavorites from '../hooks/useFavorites';
function StopDetails() {
  const { stopId } = useParams();
  const location = useLocation();
  const cameFromMap = location.state?.from === 'map';
  const [departures, setDepartures] = useState([]);
  const [stopInfo, setStopInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('departures');
  const { favoriteStops, toggleFavorite } = useFavorites(stopInfo ? [stopInfo] : []);
  const isFavorite = favoriteStops.some(id => String(id) === String(stopId));

  useEffect(() => {
    const getStopInfo = async () => {
      try {
        const stopsData = await fetchStops();
        const stop = stopsData.find(s => String(s.stopId) === String(stopId));
        setStopInfo(stop);
      } catch (error) {
        setError('Nie udało się pobrać informacji o przystanku');
      }
    };
    getStopInfo();
  }, [stopId]);

  useEffect(() => {
    const getDepartures = async () => {
      try {
        setLoading(true);
        const departuresData = await fetchDepartures(stopId);
        setDepartures(departuresData);
        setLoading(false);
      } catch (error) {
        setError('Nie udało się pobrać rozkładu jazdy');
        setLoading(false);
      }
    };
    getDepartures();
    const interval = setInterval(getDepartures, 30000);
    return () => clearInterval(interval);
  }, [stopId]);

  if (loading) return <div className="loading">Ładowanie rozkładu jazdy...</div>;
  if (error) return <div className="error">{error}</div>;


  return (
    <div className="stop-details-container">
      <Link to={cameFromMap ? "/mapa" : "/"} className="back-button">
        {cameFromMap ? "← Powrót do mapy" : "← Powrót do listy przystanków"}
      </Link>

      <StopHeader
        stopInfo={stopInfo}
        isFavorite={isFavorite}
        onToggleFavorite={(e) => {
          toggleFavorite(e, stopId);
        }}
      />

      <div className="stop-tabs">
        <button
          className={`stop-tab ${activeTab === 'departures' ? 'stop-tab--active' : ''}`}
          onClick={() => setActiveTab('departures')}
        >
          Odjazdy
        </button>
        <button
          className={`stop-tab ${activeTab === 'timetable' ? 'stop-tab--active' : ''}`}
          onClick={() => setActiveTab('timetable')}
        >
          Rozkład jazdy
        </button>
      </div>

      {activeTab === 'departures' && (
        <>
          <DeparturesList departures={departures} />
        </>
      )}

      {activeTab === 'timetable' && (
        <StopTimetable stopId={stopId} />
      )}
    </div>
  );
}

export default StopDetails;